module.exports = __webpack_public_path__ + "static/media/teri_williams.70683209.png";